import { RGBColor } from 'react-color';
import type { WithStyles } from '@material-ui/core/styles';
import type { styles } from './MobileDesignConfig.styles';

export interface MobileDesignProduct {
  key: string;
  name?: string;
  [key: string]: unknown;
}

export interface MobileDesignSection {
  key: string;
  name: string;
  products: Record<string, MobileDesignProduct>;
  [key: string]: unknown;
}

export interface MobileDesignConfigState {
  isLoading: boolean;
  loadingCropper: boolean;
  name: string;
  newProductsDescription: string;
  facebook: string | null;
  instagram: string | null;
  linkedin: string | null;
  titleDescription: string;
  clientSpace: string;
  products: Record<string, MobileDesignProduct>;
  sections: MobileDesignSection[] | Record<string, MobileDesignSection>;
  allSections: MobileDesignSection[] | Record<string, MobileDesignSection>;
  isLoadingProducts: boolean;
  splashBackgroundColor: string | null | undefined;
  url?: string | null;
  selected?: number;
  productShopIdMap?: Map<string, string>;
}

export interface SplashValidationMessage {
  text?: string;
  [key: string]: unknown;
}

export interface SplashColorState {
  displayColorPickerSplash: boolean;
  newSplashColor: string;
  backgroundSplash: RGBColor | null;
  splashValidationMessage: SplashValidationMessage | null;
}

export type MobileDesignSetState = (updates: Partial<MobileDesignConfigState>) => void;

export interface MobileDesignConfigMappedProps {
  url?: string | null;
  facebook?: string | null;
  instagram?: string | null;
  linkedin?: string | null;
  titleDescription?: string;
  clientSpace?: string;
  myLoyalty?: unknown;
  name?: string;
  newProducts?: Record<string, MobileDesignProduct>;
  newProductsDescription?: string;
  myAccount?: unknown;
  myOrders?: unknown;
  slides?: string[];
  enabled?: boolean;
  splashBackgroundColor?: string;
}

export interface MobileDesignConfigExternalProps extends MobileDesignConfigMappedProps {
  config?: string;
  selected?: number;
  selectedProduct?: number;
  openErrorModal: (message: string) => void;
}

export type MobileDesignConfigClasses = WithStyles<typeof styles>['classes'];

export enum MobileDesignConfigView {
  NONE = '',
  MEDIAS = 'Médias',
  TEXT = 'Texte',
  PRODUCTS = 'Produits',
  LINKS = 'Liens'
}

export enum MobileDesignImageKey {
  LOYALTY = 'fedilityImage',
  PROFILE = 'myAccountPicture',
  ORDERS = 'myOrdersPicture'
}
